import React, { useState } from 'react'
import moment from 'moment'
import { Row, Cell } from 'components/Table'
import Dialog from 'components/Popup/Dialog'
import { Popup as Modal } from 'components/Popup'
import { getMessage } from 'lib/translator'
import ScanRewardDetailsModal from './ScanRewardDetailsModal'
import './style.scss'

function ScanRewardRow({ id, reward, issued_at, campaignId, customerId }) {
  const [errorDialogPopup, setErrorDialogPopup] = useState(null)
  const [showDetailsModal, setShowDetailsModal] = useState(false)

  const getRewardTime = (time) => time && moment(time).format('hh:mm A')
  const getRewardDate = (date) => date && moment(date).format('D MMM YYYY')

  // Get filter parameters from URL if not provided as props
  const getFilterParams = () => {
    if (campaignId || customerId) {
      return { campaignId: campaignId || '', customerId: customerId || '' }
    }
    const searchParams = new URLSearchParams(window.location.search)
    return {
      campaignId: searchParams.get('campaign_id') || '',
      customerId: searchParams.get('customer_id') || '',
    }
  }

  const { campaignId: finalCampaignId, customerId: finalCustomerId } =
    getFilterParams()

  const handleRowClick = (e) => {
    e.preventDefault()
    setShowDetailsModal(true)
  }

  return (
    <>
      {errorDialogPopup && (
        <Dialog
          className="error-dialog"
          show={!!errorDialogPopup}
          title="Error"
          information={errorDialogPopup}
          close={() => setErrorDialogPopup(null)}
          closeText={getMessage('dialog.okText')}
        />
      )}
      {showDetailsModal && (
        <Modal
          heading={`Scan Reward #${id}`}
          className="scan-reward-details-modal"
          show={showDetailsModal}
          close={() => setShowDetailsModal(false)}
        >
          <ScanRewardDetailsModal
            rewardId={id}
            campaignId={finalCampaignId}
            customerId={finalCustomerId}
          />
        </Modal>
      )}
      <Row
        className="scan-rewards-table-row"
        key={`row-${id}`}
        onClick={handleRowClick}
      >
        <Cell>
          <div>{id}</div>
        </Cell>

        <Cell className="scan-reward-end-time">
          <div>{reward?.rewardValue || ''}</div>
        </Cell>

        <Cell className="scan-reward-start-time">
          <div>{getRewardDate(issued_at)}</div>
          <div className="time text-muted">{getRewardTime(issued_at)}</div>
        </Cell>
      </Row>
    </>
  )
}

export default ScanRewardRow
